<template>
<div>
    <div class="content-header row"></div>
    <div class="content-body"><!-- stats -->

        <div class="row match-height" v-if="editing || adding">
            <div class="col-md-12"><div class="card">
                <div class="card-header">
                    <h4 class="card-title" v-if="editing"><i class="icon-profile"></i> {{$t('users.addUsr.title.change')}}</h4>
                    <h4 class="card-title" v-if="adding"><i class="icon-user-plus"></i> {{$t('users.addUsr.title.add')}}</h4>
                    <div class="heading-elements">
                        <button type="button" class="btn btn-warning" @click="cancelChanges()" data-html="true" :title=" $t('tasks.hint.close')">
                            <i style="color: #FFFFFF" class="icon-cross"></i>
                        </button>
                    </div>
                </div>
            
                <div class="card-body">
                    <div class="card-block">
                    <form class="form">    
                    <!--body block-->
                        
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group mb-0">
                                        <label for="projectinput3">{{$t('users.table.login')}}</label>
                                        <input type="text" class="form-control" :class="{ 'border-danger': $v.changeUsr.login.$error }" placeholder="" v-model.trim="$v.changeUsr.login.$model">
                                    </div>
                                    <span v-if="$v.changeUsr.login.$error" style="color: red">
                                        <span class="d-flex" v-if="$v.changeUsr.login.$error">{{$t('errors.required')}}</span>
                                    </span>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group mb-0">
                                        <label for="projectinput1">{{$t('users.table.name')}}</label>
                                        <input type="text" class="form-control" :class="{ 'border-danger': $v.changeUsr.username.$error }" placeholder="" v-model.trim="$v.changeUsr.username.$model">
                                    </div>
                                    <span v-if="$v.changeUsr.username.$error" style="color: red">
                                        <span class="d-flex" v-if="$v.changeUsr.username.$error">{{$t('errors.required')}}</span>
                                    </span>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="edrpo">{{$t('users.table.edrpo')}}</label>
                                        <div class="input-group">
                                            <input type="text" id="edrpo" class="form-control" :class="{ 'border-danger': ($v.changeUsr.edrpo.$error && $v.changeUsr.clientGuid.$error) }" placeholder="" @keyup.enter="findClient()" v-on:change="findClient()" v-model.trim="$v.changeUsr.edrpo.$model">

                                            <div class="input-group-append">
                                                <button type="button" class="btn btn-primary btn-round" @click="findClient()">
                                                    <i class="icon-search4" ></i>
                                                </button>
                                            </div>
                                        </div>
                                        <span v-if="$v.changeUsr.edrpo.$error" style="color: red">
                                            <span class="d-flex" v-if="$v.changeUsr.edrpo.$error">{{$t('errors.required')}}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group mb-0">
                                        <label for="nameClient">{{$t('users.table.nameClient')}}</label>
                                        <input type="text" id="nameClient" class="form-control" :class="{ 'border-danger': $v.changeUsr.clientGuid.$error }" placeholder="" v-model="changeUsr.nameClient" disabled>
                                    </div>
                                    <span v-if="$v.changeUsr.clientGuid.$error" style="color: red">
                                        <span class="d-flex" v-if="$v.changeUsr.clientGuid.$error">{{$t('users.errors.organization')}}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row">

                                <div class="col-md-3" v-if="adding">
                                    <div class="form-group mb-0">
                                        <label for="projectinput4">{{$t('users.table.password')}}</label>
                                        <input type="password" class="form-control" placeholder="*************" :class="{ 'border-danger': $v.changeUsr.password.$error}" v-model.trim="$v.changeUsr.password.$model">
                                    </div>
                                    <span v-if="$v.changeUsr.password.$error" style="color: red">
                                        <span class="d-flex" v-if="$v.changeUsr.password.$error">{{$t('errors.required')}}</span>
                                    </span>
                                    
                                </div>
                                <div class="col-md-3" v-if="adding">
                                    <div class="form-group mb-0">
                                        <label for="projectinput3">{{$t('users.table.email')}}</label>
                                        <input type="text" class="form-control" placeholder="E-mail" :class="{ 'border-danger': $v.changeUsr.email.$error}" v-model.trim="$v.changeUsr.email.$model">
                                    </div>
                                    <span v-if="$v.changeUsr.email.$error" style="color: red">
                                        <span class="d-flex" v-if="$v.changeUsr.email.$error">{{$t('errors.required')}}</span>
                                    </span>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group mb-0">
                                        <label for="projectinput4">{{$t('users.table.phone')}}</label>
                                        <input type="text" class="form-control" :class="{ 'border-danger': $v.changeUsr.phone.$error }" placeholder="0991231212" v-model.trim="$v.changeUsr.phone.$model">
                                    </div>
                                    <span v-if="$v.changeUsr.phone.$error" style="color: red">
                                        <span class="d-flex" v-if="$v.changeUsr.phone.$error">{{$t('errors.required')}}</span>
                                    </span>
                                </div>
                                
                                <div class="col-md-3">
                                    <label>{{$t('users.table.roles')}}</label>
                                    <div class="input-group">
                                        <div class="form-control border-primary" :class="{ 'border-danger': $v.changeUsr.roles.$error }" style="background-color: #eceeef" id="roles" @click="showRoles = !showRoles">
                                            {{$t('users.table.roles')}}
                                        </div>

                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-primary btn-round" @click="showRoles = !showRoles">
                                                <a class="dropdown-toggle" style="color: white"></a>
                                            </button>
                                        </div>
                                        <div class="dropdown-menu" v-if="showRoles">
                                            <button class="dropdown-item" type="button" v-for="(role, index) in $store.state.roles" :key="index" @click="showRoles = false; addRole(role.val)">
                                                {{$t('titles.roles.' + role.val + '.title')}}
                                            </button>
                                        </div>
                                    </div>
                                    <span v-if="$v.changeUsr.roles.$error" style="color: red">
                                        <span class="d-flex" v-if="$v.changeUsr.roles.$error">{{$t('users.errors.emptyrole')}}</span>
                                    </span>
                                    
                                    <div class="row"><div class="col-md-12">
                                            <div class="form-group" v-if="changeUsr.roles.length > 0">
                                                <span v-for="(role,index) in changeUsr.roles" :key="index" class="btn tag-default btn-warning" style="margin: 0.2rem">
                                                    {{$t('titles.roles.' + role + '.title')}} <a @click="changeUsr.roles.splice(index, 1)" data-html="true" :title=" $t('equipm.hint.delete')"><i class="icon-bin"></i></a>
                                                </span>
                                            </div></div>
                                    </div>                             
                                </div>

                            </div>
                    <!--body block-->
                    <div class="form-actions right">
                        <button type="button" class="btn btn-primary" @click="saveChanges"><i class="icon-cloud-upload"></i> {{$t('users.saveChanges')}}</button>
                    </div>
                    </form>
                </div>
            </div>

            </div></div>
        </div>

        <div class="row match-height">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title"><i class="icon-users2"></i> {{ $t('titles.users')}}</h4>
                        <div class="heading-elements">
                            <button v-if="$store.state.listRole.dispatcher || $store.state.listRole.admin" type="button" class="btn btn-warning" @click="adding = true; editing = false; $v.$reset(); clearChange()" data-html="true" :title=" $t('users.addUsr.title.add')">
                                <i style="color: #FFFFFF" class="icon-user-plus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="card-block pb-0">
                            <div class="">
                                <fieldset class="form-group position-relative" data-html="true" :title=" $t('tasks.hint.find')">
                                    <input type="text" class="form-control form-control-lg input-lg" placeholder="" v-model="filterStr">
                                    <div class="form-control-position">
                                        <i class="icon-search4 font-medium-4"></i>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>{{$t('users.table.login')}}</th>
                                        <th>{{$t('users.table.name')}}</th>
                                        <th>{{$t('users.table.nameClient')}}</th>
                                        <th>{{$t('users.table.roles')}}</th>
                                        <th>{{$t('users.table.phone')}}</th>
                                        <th>{{$t('users.table.dtReg')}} <a @click="sortData('dt')"><i class="icon-sort"></i></a></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="user in paginatedData" :key="user.userGuid">
                                        <td :data-title="$t('users.table.login')" class="text-truncate"><a>{{user.login}}</a></td>
                                        <td :data-title="$t('users.table.name')" class="text-truncate">{{user.name}}</td>
                                        <td :data-title="$t('users.table.nameClient')">{{user.nameClient}}</td>
                                        <td :data-title="$t('users.table.roles')" >
                                            <span class="tag tag-default" style="margin-right: 5px" v-for="roles in user.role" :key="roles" :class="$t('titles.roles.' + roles + '.class')">
                                                {{ $t('titles.roles.' + roles + '.title') }}
                                            </span>
                                        </td>
                                        <td :data-title="$t('users.table.phone')" class="text-truncate"><span class="tag tag-default tag-success">{{user.tel}}</span></td>
                                        <td :data-title="$t('users.table.dtReg')"><span >{{user.date}}</span></td>
                                        <td>
                                            <button v-if="$store.getters.getDispatcher || $store.getters.getAdmin" type="button" class="btn btn-warning" @click="usrDataChange(user)" data-html="true" :title=" $t('users.addUsr.title.change')"><i class="icon-pencil22"></i></button>
                                            <button v-if="$store.getters.getAdmin || $store.getters.getDispatcher" type="button" class="btn btn-secondary" @click="remove(user)" data-html="true" :title=" $t('users.hint.delete')"><i class="icon-bin"></i></button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        <div class="" style="text-align: center;">
                            <ul class="pagination">
                                <li class="page-item" v-if="pageNumber > 0">
                                    <a class="page-link" @click="prevPage" ><i class="icon-arrow-left2"></i></a>
                                </li>
                                
                                <li class="page-item" v-bind:class="{active : (pageNumber == (page - 1))}" v-for="(page, index) in pages" :key="index" >
                                    <a v-if="page != '...'" class="page-link" @click="pageNumber = (page - 1)">{{page}}</a>
                                    <a v-else class="page-link" :id="index">{{page}}</a>
                                </li>
                                
                                <li class="page-item" v-if="pageNumber < pageCount - 1">
                                    <a class="page-link"  @click="nextPage"><i class="icon-arrow-right2"></i></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { required, minLength,  sameAs, email } from 'vuelidate/lib/validators'

  export default {
  components: {},
    name: "Users",
    data(){
      return{
        errors: [],
        listUsers: [],
        listClients: [],

        sortKey: 'dt',
        direction: 'desc',
        boolDir: false,
        classSort: 'icon-sort-amount-asc',

        role: {
            user: false,
            dispatcher: false,
            client: false,
            service: false,
            serviceOrg: false,
            admin: false,
        },

        filterStr: "",
        changeUsr:{
            guid: null,//hidden
            username:null,
            nameClient: null,
            clientGuid: null,//hidden
            edrpo: null,
            login: null,
            password: null,
            email: null,
            phone: null,
            type: null,//always 3
            //role: null,
            roles: [],
        },
        pageNumber: 0,

        //buttons
        editing: false,
        adding: false,
        //buttons

        showRoles: false,
      }
    },
    validations: {

        changeUsr:{
            username: {required, minLength: minLength(4)},
            login: {required, minLength: minLength(4)},
            password: {required, minLength: minLength(3)},
            email: { required, email },
            phone: {required, minLength: minLength(10)},
            edrpo: {required, minLength: minLength(4)},

            clientGuid: {required},
            roles: {required, minLength: minLength(1), $each: {required}},
        },
        
    },
    props:{
        size:{
            type:Number,
            required:false,
            default: 10,
        },
        paggSize:{
            type: Number,
            required:false,
            default: 5,
        }
    },
    methods: {
        getUsers() {
            this.listUsers = [];
            this.makeQuery("/service/listuser", {token: this.$store.getters.getUserToken})
            .then(result => {

                
                for (let i = 0; i < result.length; i++) {
                    result[i].dt = Math.round(new Date( result[i].date ));
                    result[i].date = this.dtFormat(result[i].date);
                    this.listUsers.push(result[i]);
                }                
            })
            .catch(result => {this.showNotification('custom-error','Error',result); });
        },
        usrDataChange(usr){
            this.$v.$reset();
            this.clearChange();
            if (this.adding) { this.adding = false; }

            this.editing = true;

            $('html, body').animate({scrollTop: 0}, 600);//scroll to top

            this.changeUsr.guid = usr.userGuid;
            this.changeUsr.username = usr.name;
            this.changeUsr.clientGuid = usr.clientGuid;
            //this.changeUsr.edrpo = usr.edrpo;
            this.changeUsr.nameClient = usr.nameClient;
            this.changeUsr.login = usr.login;
            //this.changeUsr.password = usr.password;
            this.changeUsr.email = usr.email;
            this.changeUsr.phone = usr.tel;
            //this.changeUsr.role = usr.role[0];
            for (let i = 0; i < usr.role.length; i++) {
                this.changeUsr.roles.push(usr.role[i]);                
            }
            
        },
        findClient(){

            this.$v.changeUsr.edrpo.$touch();

            if (!this.$v.changeUsr.edrpo.$error){
                this.$v.changeUsr.edrpo.$reset();

                this.listClients = [];
                let dataRequest = {
                    edrpo: this.changeUsr.edrpo
                };
                if (dataRequest.edrpo.length > 4){
                    this.makeQuery("/service/getClient", {dataRequest: dataRequest})
                    .then(result => {

                        this.changeUsr.clientGuid = result.guidClient;
                        this.changeUsr.nameClient = result.name;

                        //this.showNotification('custom-success','Search','Found client!');
                    })
                    .catch(result => {this.showNotification('custom-error','Error',result); });
                }
            }
        },
        remove(usr){
            //if role admin
            if(this.isValid(usr.userGuid)){
                let dataRequest = {
                    userGuid: usr.userGuid
                }

                this.makeQuery("/service/deleteUser", {dataRequest: dataRequest, token: this.$store.getters.getUserToken})
                .then(result => {
                    this.getUsers();
                    this.showNotification('custom-error',usr.login,'Removed ' + usr.name);
                })
                .catch(result => {this.showNotification('custom-error','Error',result); });
            }
        },
        saveChanges(){
            if(this.editing){
                
                this.$v.changeUsr.username.$touch();
                this.$v.changeUsr.clientGuid.$touch();
                this.$v.changeUsr.login.$touch();
                this.$v.changeUsr.phone.$touch();
                this.$v.changeUsr.roles.$touch();

                if(!this.$v.changeUsr.username.$error 
                        && !this.$v.changeUsr.clientGuid.$error
                        && !this.$v.changeUsr.login.$error
                        && !this.$v.changeUsr.phone.$error
                        && !this.$v.changeUsr.roles.$error)
                {

                    //this.$v.$reset();
                    this.$v.changeUsr.username.$reset();
                    this.$v.changeUsr.clientGuid.$reset();
                    this.$v.changeUsr.login.$reset();
                    this.$v.changeUsr.phone.$reset();
                    this.$v.changeUsr.roles.$reset();

                    let dataRequest = {
                        userGuid: this.changeUsr.guid,
                        username: this.changeUsr.username,
                        login: this.changeUsr.login,
                        guidClient: this.changeUsr.clientGuid,
                        //password: null,
                        //email: null,
                        tel: this.changeUsr.phone,
                        type: "3",
                        role: this.changeUsr.roles
                    };

                    this.makeQuery("/service/editUser", { dataRequest: dataRequest, token: this.$store.getters.getUserToken })
                    .then(result => {
                        this.showNotification('custom-success','Changing','Зміни збережено');
                        this.editing = false;
                        this.getUsers();
                    })
                    .catch(result => {this.showNotification('custom-error','Error',result); });
                }

                

            } else if(this.adding){
                this.$v.changeUsr.username.$touch();
                this.$v.changeUsr.login.$touch();
                this.$v.changeUsr.phone.$touch();
                this.$v.changeUsr.email.$touch();
                this.$v.changeUsr.password.$touch();
                this.$v.changeUsr.roles.$touch();

                if(!this.$v.changeUsr.username.$error
                        && !this.$v.changeUsr.login.$error
                        && !this.$v.changeUsr.phone.$error
                        && !this.$v.changeUsr.roles.$error
                        && !this.$v.changeUsr.email.$error
                        && !this.$v.changeUsr.password.$error)
                {
                    this.$v.changeUsr.username.$reset();
                    this.$v.changeUsr.login.$reset();
                    this.$v.changeUsr.phone.$reset();
                    this.$v.changeUsr.email.$reset();
                    this.$v.changeUsr.password.$reset();
                    this.$v.changeUsr.roles.$reset();

                    
                    let serviceOrg = false, dispatcher = false;

                    for (let i = 0; i < this.changeUsr.roles.length; i++) {
                        if(this.changeUsr.roles[i] == 'serviceOrg'){ serviceOrg = true; break;}
                        if(this.changeUsr.roles[i] == 'dispatcher'){ dispatcher = true; break;}
                    }

                    if ( serviceOrg || dispatcher){
                        this.$v.changeUsr.edrpo.$reset();
                        this.$v.changeUsr.clientGuid.$reset();

                        this.changeUsr.edrpo = null;
                        this.changeUsr.clientGuid = null;
                        this.changeUsr.nameClient = null;
                    } else {
                        this.$v.changeUsr.clientGuid.$touch();
                        this.$v.changeUsr.edrpo.$touch();
                        if (this.$v.changeUsr.edrpo.$error){ return }
                        if (this.$v.changeUsr.clientGuid.$error){ return }
                    }

                    let dataRequest = {
                        //userGuid: null,
                        username: this.changeUsr.username,
                        login: this.changeUsr.login,
                        password: this.changeUsr.password,
                        email: this.changeUsr.email,
                        edrpo: this.changeUsr.edrpo,
                        guidClient: this.changeUsr.clientGuid,
                        nameClient: this.changeUsr.nameClient,
                        tel: this.changeUsr.phone,
                        type: "3",
                        role: this.changeUsr.roles
                    };

                    this.makeQuery("/service/addUser", {dataRequest: dataRequest, token: this.$store.getters.getUserToken})
                    .then(result => {
                        this.showNotification('custom-success','Register',result);
                        this.adding = false;
                        this.getUsers();
                    })
                    .catch(result => {this.showNotification('custom-error','Error',result); });

                }
                           
            }
        },
        cancelChanges(){
            this.adding = false;
            this.editing = false;
            this.clearChange();
        },
        nextPage(){
            this.pageNumber++;
        },
        prevPage(){
            this.pageNumber--;
        },
        clearChange(){
            this.changeUsr.guid = null;
            this.changeUsr.username = null;
            this.changeUsr.nameClient = null;
            this.changeUsr.clientGuid = null;
            this.changeUsr.edrpo = null;
            this.changeUsr.login = null;
            this.changeUsr.password = null;
            this.changeUsr.email = null;
            this.changeUsr.phone = null;
            this.changeUsr.type = null;
            //this.changeUsr.role = null;
            this.changeUsr.roles = [];
        },
        addRole(role){
            let foundScanned = false;
            for (let j = 0; j < this.changeUsr.roles.length; j++) {
                if(this.changeUsr.roles[j] == role){
                    foundScanned = true;
                    break;
                }
            }
            if(!foundScanned){
                this.changeUsr.roles.push(role);
            }
        },
        sortData(key){
            if (this.sortKey == key){
                this.boolDir = !this.boolDir;
            } else {
                this.boolDir = false;
            }
            if (this.boolDir){
                this.direction = 'asc';
                this.classSort = 'icon-sort-amount-asc';
            } else {
                this.direction = 'desc';
                this.classSort = 'icon-sort-amount-desc';
            }

            this.sortKey = key;
        },
    },
    watch:{},
    created() {
        
    },
    mounted(){
        this.checkAuthorized().then(result => {
            this.getUsers();//first on run 
        })
        .catch(err => {
            this.showNotification('custom-error',this.$t('errors.title'),this.$t('errors.500'));
        });

        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
    },
    computed: {
        pageCount(){
            let l = this.listUsrSorted.length, s = this.size;
            return Math.ceil(l/s);
        },
        pages: function(){
            let arr = [];
            for (let i = 0; i < this.pageCount; i++) { 
                arr[i] = i + 1;
            }
            let divider = Math.trunc(this.paggSize/2);
            let start = this.pageNumber - divider;
            let end = this.pageNumber + divider + 1;
            if (start < 0) {
                start = 0;
            }
            let final_arr = arr.slice(start,end);
            if ((start + 1) > arr[0]){
                final_arr.unshift('...');
            }
            if(end < arr[arr.length - 1]){
                final_arr.push('...');
            }
            return final_arr;
        },
        paginatedData(){
            const start = this.pageNumber * this.size,
                end = start + this.size;
            return this.sortedData.slice(start, end);
        },
        listUsrSorted: function(){
            this.pageNumber = 0;
            let find = this.filterStr.toLowerCase();
            if((find != '') && (this.listUsers.length > 0)){
                return this.listUsers.filter(function(item){
                    if (item.login.toLowerCase().indexOf(find) > -1){ return item } else
                    if ((item.nameClient != null) && (item.nameClient.toLowerCase().indexOf(find) > -1)){ return item } else
                    if ((item.tel != null) && (item.tel.toLowerCase().indexOf(find) > -1)){ return item } else
                    if ((item.name != null) && (item.name.toLowerCase().indexOf(find) > -1)){ return item }
                })
            } else {
                return this.listUsers;
            }
        },
        sortedData: function () {
            return _.orderBy(this.listUsrSorted, this.sortKey, this.direction);
        },
    }
}
</script>
<style scoped>
.border-danger{
  border: 3px solid #DA4453 !important;
}

@media only screen and (max-width: 800px) {
	.marginTR{
        margin-bottom: 1rem;
    }
    .paddingTD{
        padding: 0.5rem;
    }
	/* Force table to not be like tables anymore */
	table, thead, tbody, th, td, tr { 
		display: block; 
	}
 
	/* Hide table headers (but not display: none;, for accessibility) */
	thead tr { 
		position: absolute;
		top: -9999px;
		left: -9999px;
	}
 
	tr { border: 1px solid #ccc;}
 
	td { 
		/* Behave  like a "row" */
		border: none;
		border-bottom: 1px solid #eee; 
		position: relative;
		padding-left: 50%; 
		white-space: normal;
		text-align:left;
        min-height: 2rem;
	}
 
	td:before { 
		/* Now like a table header */
		position: absolute;
		/* Top/left values mimic padding */
		top: 6px;
		left: 6px;
		width: 45%; 
		padding-right: 10px; 
		white-space: nowrap;
		text-align:left;
		font-weight: bold;
	}
 
	/*
	Label the data
	*/
	td:before { content: attr(data-title); }
}
</style>



// WEBPACK FOOTER //
// src/pages/Users.vue